import {
  createStore,
  Store,
  applyMiddleware,
  compose,
} from 'redux'
import rootReducer, { IDetailPageState } from './reducers'
import { loggerMiddleware } from './middleware/logging'
import { Logger, RequestContext, safeBool } from 'DVWebNodeUtils'
import { DetailPageActionTypes } from './actions/constants'
import { DetailPageActions } from './actions'

export let store: Store<IDetailPageState, DetailPageActions>

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}

export const resetStore = () => {
  store && store.dispatch({
    type: DetailPageActionTypes.RESET_STORE,
    payload: {},
  })
}

export const configureStore = (
  partialState: Partial<IDetailPageState> & { requestContext: RequestContext },
  logger: Logger
) => {
  const isInternal = safeBool(partialState.requestContext.isInternal || '0')

  if (global.__SERVER__ && !global.__DEVSERVER__) {
    return createStore(rootReducer, partialState)
  } else {
    if (store) {
      store.dispatch({
        type: DetailPageActionTypes.STORE_MERGE,
        payload: partialState,
      })
    } else {
      const middleware = [loggerMiddleware(logger, isInternal)]
      if (isInternal) {
        logger.info('➡ Initial State', partialState)
      }

      const composeEnhancers = (isInternal && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

      store = createStore(rootReducer, partialState, composeEnhancers(applyMiddleware(...middleware)))
    }

    return store
  }
}
